import React from "react";
import { notification, NotificationProps } from "@stemscopes/ui";
import { PartialBy } from "types";
import i18n from "configs/i18n";
import Typography from "../typography";
import Icon from "../icon";
import Button from "../button";
import styles from "./notification.module.css";

i18n.then((t) =>
  notification.setConfig({
    duration: 5000,
    position: "topRight",
    containerClassName: styles.container,
    closeButton: (
      <Button
        title={t("notification.close")}
        variant="clear"
        size="small"
        prefix={
          <Icon
            name="close-outlined"
            size="small"
            className={styles.closeIcon}
          />
        }
        iconOnly
        className={styles.close}
      >
        {t("notification.close") as React.ReactNode}
      </Button>
    ),
  }),
);

const getContent = (children: React.ReactNode): React.ReactNode => (
  <Typography component="div" variant="p2">
    {children}
  </Typography>
);

const getTitle = (title: React.ReactNode): React.ReactNode =>
  title ? (
    <Typography component="div" variant="s1">
      {title}
    </Typography>
  ) : null;
type NotificationConfig = PartialBy<Omit<NotificationProps, "type">, "title">;

export const createSuccess = ({
  title,
  content,
  duration,
}: NotificationConfig): // p0?: { content: Notification },
// p1?: boolean,
// p2?: null
string =>
  notification.success({
    title: getTitle(title),
    content: getContent(content),
    icon: <Icon name="check-colored" className={styles.icon} />,
    duration,
  });

export const createInfo = ({
  title,
  content,
  duration,
  ...props
}: NotificationConfig): // p0?: boolean
string =>
  notification.info({
    ...props,
    title: getTitle(title),
    content: getContent(content),
    icon: <Icon name="info-circle-colored-warning" className={styles.icon} />,
    duration,
  });

export const createError = ({ title, content }: NotificationConfig): string =>
  notification.success({
    title: getTitle(title),
    content: getContent(content),
    icon: <Icon name="warning-colored-danger" className={styles.icon} />,
  });

export const { destroy, destroyAll } = notification;
